'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UpdateCP(username, pin, base64Cert) {
  this.a09 = null;
  this.a08 = null;
  this.a07 = null;
  this.a09 = username;
  this.a08 = pin;
  this.a07 = base64Cert;
}
export { $c_Lpresto_types$proto$UpdateCP as $c_Lpresto_types$proto$UpdateCP };
$p = $c_Lpresto_types$proto$UpdateCP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UpdateCP;
/** @constructor */
function $h_Lpresto_types$proto$UpdateCP() {
}
export { $h_Lpresto_types$proto$UpdateCP as $h_Lpresto_types$proto$UpdateCP };
$h_Lpresto_types$proto$UpdateCP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$UpdateCP)) {
    if ((this.a09 === x$0.a09)) {
      var x = this.a08;
      var x$2 = x$0.a08;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.a07;
      var x$4 = x$0.a07;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "UpdateCP";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.a09;
      break;
    }
    case 1: {
      return this.a08;
      break;
    }
    case 2: {
      return this.a07;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$UpdateCP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mb)));
}
export { $isArrayOf_Lpresto_types$proto$UpdateCP as $isArrayOf_Lpresto_types$proto$UpdateCP };
var $d_Lpresto_types$proto$UpdateCP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UpdateCP, "presto.types$proto$UpdateCP", ({
  mb: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UpdateCP as $d_Lpresto_types$proto$UpdateCP };
//# sourceMappingURL=presto.types$proto$-Update-C-P.js.map
